import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from "src/app/services/language/language.service"
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'azizlassoued-portfolio';
  
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private translateService: TranslateService,
    private location: Location,
    private languageService: LanguageService
    ){
    }
  ngOnInit(): void{
    
    this.languageService.initLanguage()


    this.titleService.setTitle( "Aziz lassoued | Frontend Developer" );

    this.metaService.addTags([
      {name: 'keywords', content: 'Frontend, software, developer'},
      {
        name: 'description',
        content: 'Avec 3 ans d’expérience dans le développement de systèmes, d’interfaces, de bots et de solutions technologiques, je m’efforce de rendre le web meilleur. J’aime diriger, proposer et mettre en œuvre des idées, ainsi qu’écrire et refactoriser du code propre, réutilisable et évolutif.'
      }
          ]);
    
    
    AOS.init(); 

  }
}
